// eslint-disable-next-line
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="mt-16 flex flex-col items-center justify-center bg-gray-100 text-center">
      <h1 className="text-9xl font-extrabold text-red-500 mb-4 animate-pulse">404</h1>
      <p className="text-2xl md:text-3xl text-gray-700 font-semibold mb-6">
        Oops! The page you're looking for doesn't exist.
      </p>
      <p className="text-gray-500 mb-8">
        It might have been removed or the link may be broken.
      </p>
      <Link
        to="/"
        className="w-fit flex items-center gap-2 rounded  justify-center text-white bg-black font-bold px-4 py-2 transition-all duration-300 ease-in-out  hover:bg-red-600"

      >
        Return Home
      </Link>
     
    </div>
  );
};

export default NotFound;
